import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2avb9l31mifva">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-34" data-mp="38ap80y11ice3">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-5 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_14px_30px_-8px_rgba(0,0,0,0.45)] ring-2 ring-white transition-colors duration-150 ease-out hover:bg-ctaDark" data-id="element-35" data-mp="333b19fcanasn">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="2fg2v6v71jxpk" />
            Get it now for $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}